import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useAppSelector } from "appRedux/hooks"
import { updateGenies } from "appRedux/slices/wishListSlice"
import { useLazyGetGeniesQuery, wishItemApi } from "appRedux/slices/wishItemApiSlice"

export default function useGetGenies(id?: number, cameTrue?: boolean) {
  const cachedCurrentItemGenies = useAppSelector((state) => id ? wishItemApi.endpoints.getGenies.select(id)(state) : null)

  const [triggerGetGenies, getGeniesResult] = useLazyGetGeniesQuery()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!id) return
    if (cachedCurrentItemGenies?.data) {
      dispatch(updateGenies({ id, genies: cachedCurrentItemGenies?.data?.genies || [] }))
      return
    }
    fetchGenies()
  }, [id])

  function fetchGenies() {
    if (!id) return
    if (!cameTrue) return
    triggerGetGenies(id)
  }

  return {
    genies: cachedCurrentItemGenies?.data?.genies || getGeniesResult?.data?.genies || [],
    isFetching: getGeniesResult.isFetching,
    isError: getGeniesResult.isError
  }
}
